import apiClient from '$utils/apiClient';

const formatParticipant = (participant) => ({
  ...participant,
  fullName: `${participant.firstName} ${participant.lastName}`,
});

// eslint-disable-next-line import/prefer-default-export
export const fetchParticipants = async ({ spaceId }) => {
  const {
    data: { participants },
  } = await apiClient.get(
    `/spaces/${spaceId}/participants?limit=2000`, // @FIXME, not suitable for large space
    {
      withCredentials: true,
    }
  );

  return participants.map(formatParticipant);
};
